import React from 'react';
import './Contactus.css';

const Contact = () => {
  return (
    <div className="contact-wrapper">
      <h1>Contact Us</h1>
      <div className="contact-content">
        {/* Contact Details */}
        <div className="contact-info">
          <h2>Get In Touch</h2>
          <p><strong>Address:</strong> <br/> Plot no 40, Dhanraj Nagar, Degam Rd, <br/>
          opp. Seema complex, Dungri Faliya,
          <br/> Phase 3, GIDC, Vapi, Gujarat 396191</p>
          <p><strong>Office:</strong> <br/> +91 98241 94704</p>
          <p><strong>Alpesh Bhayani:</strong> <br/> +91 98247 44940</p>
          <p><strong>Trupesh Bhayani:</strong> <br/> +91 97238 03380</p>
          <p><strong>Email:</strong> <br/> info@chemisalt.com <br/>chemisaltcorp@gmail.com</p>
          <p><strong>Hours:</strong> <br/> Mon - Sat, 9:00 AM - 6:00 PM</p>
        </div>

        {/* Contact Form */}
        <form className="contact-form">
          <h2>Send a Message</h2>
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <input type="text" placeholder="Subject" required />
          <textarea placeholder="Your Message" rows="5" required></textarea>
          <button type="submit">Send Message</button>
        </form>
      </div>

      {/* Map */}
      <div className="contact-map">
        <iframe 
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3744.331393693356!2d72.9366308!3d20.3072554!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be0c39f280a5e8f%3A0x8e83161df28a2a8c!2sDegam%20Rd%2C%20GIDC%20Phase%20III%2C%20Vapi%2C%20Gujarat%20396191!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin" 
          width="100%" 
          height="450" 
          style={{ border: 0 }} 
          allowFullScreen="" 
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
